export default function removeDoubledCommas(string?: string) {
  if (!string) return ''
  return string
    .replaceAll(', ,', ', ')
    .replaceAll(',,', ', ')
    .replaceAll('  ', ' ')
    .trim()
}
